// Two-letter initials for a club/user name, used by the mono "initials tile"
// fallback when no logo/avatar is available (Clubs tab, Profile, admin lists).
// Empty/missing name → "" (render an empty tile, not "??").
export function getClubInitials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
